import React from 'react';
import NavigationalCard from '../navigationalCard';
import {
	Columns,
	Column
} from '../base';
import * as StyledNavigationalCards from './navigationalCards.styles';

const NavigationalCards = ({ cards }) => {
	return (
		<StyledNavigationalCards.Wrapper>
			<StyledNavigationalCards.Container>
				<Columns>
					{
						cards.map((card, index) => {
							return (
								<Column tablet={1 / 2} key={index}>
									<NavigationalCard {...card.Values} />
								</Column>
							);
						})
					}
				</Columns>
				<StyledNavigationalCards.Decoration />
			</StyledNavigationalCards.Container>
		</StyledNavigationalCards.Wrapper>
	);
};

export default NavigationalCards;
